import React from 'react'

import { TestimonialComponent } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Carousel } from '@organisms/Carousel'

import { TitleSection } from './Testimonial.styled'
import { TestimonialItem } from './TestimonialItem/TestimonialItem'

export const Testimonial = ({ testimonialTitle, subtitle, testimonial, mode }: TestimonialComponent): JSX.Element => {
    return (
        <TitleSection title={testimonialTitle} subtitle={subtitle} mode={mode}>
            <Grid container>
                <Carousel>
                    {testimonial.map((item, i) => (
                        <TestimonialItem item={item} key={`${i}-${item.customerName}`} />
                    ))}
                </Carousel>
            </Grid>
        </TitleSection>
    )
}
